import { ActionTree } from 'vuex';

import { TabViewModel } from '../../models/common/tab-view.model';
import {
    ITabViewState,
    TAB_VIEW_ACTIONS,
    TAB_VIEW_MUNTATIONS,
    AddTabParamModel,
    SetUnsavedDataParamModel,
    UpdateTabIdParamModel
} from './tab-view-types.store';

export const actions: ActionTree<ITabViewState, any> = {
    [TAB_VIEW_ACTIONS.ADD_TAB]({ commit }, payload: AddTabParamModel): void {
        commit(TAB_VIEW_MUNTATIONS.ADD_TAB, payload);
    },
    [TAB_VIEW_ACTIONS.REMOVE_TAB]({ commit }, payload: TabViewModel): void {
        commit(TAB_VIEW_MUNTATIONS.REMOVE_TAB, payload);
    },
    [TAB_VIEW_ACTIONS.SET_UNSAVED_DATA_STATE]({ commit }, payload: SetUnsavedDataParamModel) {
        commit(TAB_VIEW_MUNTATIONS.SET_UNSAVED_DATA, payload);
    },
    [TAB_VIEW_ACTIONS.SET_TAB_VIEWS]({ commit }, payload: Array<TabViewModel>) {
        commit(TAB_VIEW_MUNTATIONS.SET_TAB_VIEWS, payload);
    },
    [TAB_VIEW_ACTIONS.ADD_QUERY_STRING_TAB_VIEW]({ commit }, payload: Object) {
        commit(TAB_VIEW_MUNTATIONS.ADD_QUERY_STRING_TAB_VIEW, payload);
    },
    [TAB_VIEW_MUNTATIONS.SET_CALLBACK_CLOSE_TAB_VIEW]({ commit }, payload: Function) {
        commit(TAB_VIEW_MUNTATIONS.SET_CALLBACK_CLOSE_TAB_VIEW, payload);
    },
    [TAB_VIEW_ACTIONS.SET_CALLBACK_CLEAR_MEMORY]({ commit }, payload: Function) {
        commit(TAB_VIEW_MUNTATIONS.SET_CALLBACK_CLEAR_MEMORY, payload);
    },
    [TAB_VIEW_ACTIONS.UPDATE_TAB_IDENTIFY_ID]({ commit }, payload: UpdateTabIdParamModel) {
        commit(TAB_VIEW_MUNTATIONS.UPDATE_TAB_IDENTIFY_ID, payload);
    },
    [TAB_VIEW_ACTIONS.UPDATE_TAB_TITLE]({ commit }, payload: {tab: TabViewModel, value: string}) {
        commit(TAB_VIEW_MUNTATIONS.UPDATE_TAB_TITLE, payload);
    },
    [TAB_VIEW_ACTIONS.UPDATE_TABVIEW_ORDER]({ commit }, payload: Array<TabViewModel>) {
        commit(TAB_VIEW_MUNTATIONS.UPDATE_TABVIEW_ORDER, payload);
    },
    [TAB_VIEW_ACTIONS.UPDATE_OLD_TAB]({ commit }, payload: any): void {
        commit(TAB_VIEW_MUNTATIONS.UPDATE_OLD_TAB, payload);
    },
}